<template>
  <element>
    <AppBar :title="title" />
    <div
      class="parts-list"
      v-bind:class="{
        'part-list-expanded': isPartMenuOpen,
        'part-list-collapsed': !isPartMenuOpen,
      }"
    >
      <b-container class="pt-0 mt-0 pl-1 ml-0 pr-2 mr-0 pb-0 mb-0">
        <b-row no-gutters class="text-left"
          ><!-- menu header -->
          <b-col class="col-3">
            <span class="part-count-badge">{{ parts.length }}</span>
          </b-col>
          <b-col class="col-4">
            <span class="part-list-label">Parts</span>
          </b-col>
          <v-spacer></v-spacer>
          <b-col class="col-3 text-right">
            <span class="part-list-toggle-btn">
              <v-icon
                @click="expandPartMenu"
                class="part-list-chevron-down"
                color="lightgrey"
                medium
                >mdi-chevron-down</v-icon
              >
              <v-icon
                @click="collapsePartMenu"
                class="part-list-close"
                color="lightgrey"
                medium
                >mdi-close</v-icon
              >
            </span>
          </b-col>
        </b-row>
        <!-- /menu header -->
        <div class="part-list-group">
          <b-row
            v-for="part in parts"
            :key="part.part_id"
            no-gutters
            class="mt-2 pt-2 pr-1 part-item"
          >
            <!-- part item -->
            <b-col cols="2"></b-col>
            <b-col cols="9">
              <b-row no-gutters>
                <b-col cols="12"
                  ><span class="part-item-oem-number">{{
                    part.oem_number
                  }}</span></b-col
                >
              </b-row>
              <b-row no-gutters>
                <b-col cols="12" class="text-truncate"
                  ><span class="part-item-name">{{ part.name }}</span></b-col
                >
              </b-row>
            </b-col>
            <b-col
              cols="1"
              class="part-item-delete-icon"
              @click="removePart(part.oem_number)"
            >
              <v-icon small>mdi-trash-can-outline</v-icon>
            </b-col>
          </b-row>
          <!-- / part item -->
        </div>
      </b-container>
    </div>
    <!-- /part list -->

    <v-container class="pt-0">
      <div class="form-container">
        <v-row no-gutters class="d-flex justify-content-center">
          <v-icon class="page-icon pb-1 ml-2" color="#2e384d" size="64"
            >mdi-car-door</v-icon
          >
        </v-row>
        <p class="new-order-desc">
          {{ $t("enterNewPart_NewOrder.description") }}
        </p>
        <form action="#" @submit.prevent="submit">
          <LabelTextField
            ref="partName"
            class="mt-2"
            :label="$t('enterNewPart_NewOrder.partName')"
          ></LabelTextField>
          <LabelTextField
            ref="oemNumber"
            class="mt-2"
            :label="$t('enterNewPart_NewOrder.oemNumber')"
            required
          ></LabelTextField>
          <v-row>
            <v-col cols="6">
              <LabelTextField
                ref="car_make_id"
                class="mt-2"
                :label="$t('enterNewPart_NewOrder.car_make_id')"
                required
              ></LabelTextField>
            </v-col>
            <v-col cols="6">
              <LabelTextField
                ref="car_model_id"
                class="mt-2"
                :label="$t('enterNewPart_NewOrder.car_model_id')"
                required
              ></LabelTextField>
            </v-col>
          </v-row>
          <LabelNumberInput
            ref="quantity"
            class="mt-2"
            :label="$t('enterNewPart_NewOrder.quantity')"
          ></LabelNumberInput>
          <v-btn
            class="submit-btn another_part"
            height="45px"
            color="#033e8c"
            depressed
            block
            dark
            @click="addPart"
          >
            {{ $t("enterNewPart_NewOrder.enterAnotherPartBtnTitle") }}
          </v-btn>
          <v-btn
            class="submit-btn finish-btn"
            height="45px"
            color="#57D701"
            depressed
            block
            dark
            @click="complete(false)"
          >
            <span>
              <img src="../assets/check.svg" />
            </span>
          </v-btn>
          <!-- </v-row> -->
        </form>
      </div>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue";
import { DOCUMENT_TYPE_PART_PICTURE } from "@/constants";
import LabelTextField from "@/components/common/LabelTextField.vue";
import LabelNumberInput from "@/components/common/LabelNumberInput.vue";

export default {
  name: "EnterNewPart_NewOrder",
  props: {},
  components: {
    AppBar,
    LabelTextField,
    LabelNumberInput,
  },
  data() {
    return {
      title: "",
      valid: false,
      partId: -1,
      documentType: DOCUMENT_TYPE_PART_PICTURE,
      part: null,
      parts: [], // store parts inputted by the user here
      isPartMenuOpen: false,
    };
  },
  methods: {
    expandPartMenu() {
      console.log("expandPartMenu()");
      this.isPartMenuOpen = true;
    },
    collapsePartMenu() {
      console.log("collapsePartMenu()");
      this.isPartMenuOpen = false;
    },
    addPart() {
      this.part = {
        name: this.$refs.partName.textValue,
        oem_number: this.$refs.oemNumber.textValue,
        quantity: this.$refs.quantity.numberInput,
        car_make_id: this.$refs.car_make_id.textValue,
        car_model_id: this.$refs.car_model_id.textValue,
      };
      this.parts.push(this.part);
      this.part = null;
      this.$refs.partName.textValue = "";
      this.$refs.oemNumber.textValue = "";
      this.$refs.car_make_id.textValue = "";
      this.$refs.car_model_id.textValue = "";
      this.$refs.quantity.numberInput = 1;
    },
    removePart(oem_number) {
      this.parts.forEach(function (item, index, object) {
        if (item.oem_number === oem_number) {
          object.splice(index, 1);
        }
      });
    },
    complete(add_new_part) {
      const taskId = this.$store.getters.getCurrentTask?.id;
      if (taskId) {
        this.$store
          .dispatch("completeTask", {
            taskId,
            variables: {
              add_new_part: add_new_part,
            },
          })
          .then((response) => {
            console.log("Task completed successfully!", taskId, response);
            this.$router.push({ name: "dashboard" });
          })
          .catch((error) => {
            console.log("Failed completing task!", taskId, error);
          })
          .finally(() => {
            console.log("Finally completing task!");
          });
      }
    },
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName;
    const pid = this.$store.getters.getCurrentPID;
    this.$refs.partName.textValue = "";
    this.$refs.oemNumber.textValue = "";
    this.$refs.car_make_id.textValue = "";
    this.$refs.car_model_id.textValue = "";
    this.$refs.quantity.numberInput = 1;

    this.$store
      .dispatch("retrieveProcessVariables", pid)
      .then((response) => {
        try {
          this.partId = parseInt(response.data.data.part_id.value);
        } catch (error) {
          console.log("Failed retrieving variables from API.", error);
        }
      })
      .catch((error) => {
        console.log("Failed retrieving variables from API", error);
      });
  },
};
</script>

<style scoped>
.parts-list {
  position: absolute;
  top: 60px;
  left: 16px;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  z-index: 999;
  padding: 5px;
  min-height: 35px;
  transition: width 0.3s;
}

.part-list-collapsed {
  height: 35px;
  width: 120px;
  overflow: hidden;
}
.part-list-expanded {
  height: auto;
  width: 350px;
}

@media screen and (max-width: 376px) {
  .part-list-expanded {
    width: 90%;
  }
}

.part-list-collapsed .part-list-toggle-btn > .part-list-close {
  display: none;
}

.part-list-collapsed .part-list-toggle-btn > .part-list-chevron-down {
  display: inherit;
}

.part-list-expanded .part-list-toggle-btn > .part-list-chevron-down {
  display: none;
}

.part-list-expanded .part-list-toggle-btn > .part-list-close {
  display: inherit;
}

.part-count-badge {
  height: 20px;
  min-height: 20px;
  min-width: 20px;
  background: #4caf50;
  border-radius: 20px;
  color: white;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  padding: 4px;
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  line-height: 12px;
}

.part-list-label {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  display: inline-block;
  color: #000000;
}

.part-list-toggle-btn > .v-icon {
  color: grey !important;
  font-size: 16px;
}

.part-item-picture {
  height: 45px;
  width: 45px;
  object-fit: cover;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.part-item-oem-number {
  font-style: normal;
  font-weight: normal;
  font-size: 11px;
  line-height: 100%;
  color: rgba(0, 0, 0, 0.63);
}

.part-item-name {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 100%;
  color: #000000;
  text-overflow: ellipsis;
}

.part-item-delete-icon {
  height: auto;
  text-align: right;
}

.part-item-delete-icon > i {
  width: 10px;
  color: red !important;
}

.part-item {
  border-top: 1px solid lightgray;
  text-align: left !important;
}

.part-list-group {
  max-height: 400px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.parts-list.part-list-collapsed .part-list-group {
  display: none;
}

.new-order-desc {
  margin-top: 1.375rem;
  margin-bottom: 2.1875vh !important;
  font-size: 0.875rem;
  font-weight: lighter;
  color: #2e384d;
}

.finish-btn {
  margin-top: 24px;
}
.form-container {
  padding: 0 8px;
}
.another_part {
  margin-top: 18px;
}
</style>
